import { MentionItem } from 'react-mentions';

import { TaggableUserOption } from 'services/api/taggableUsers';

type MentionValues = { text: string; plaintext: string; mentions: MentionItem[] };

// Append an @-mention to a composer value using react-mentions' own markup/plaintext shape.
// Shared by ActivityInput (clinical notes) and the chat Composer so the two surfaces never
// drift. Inserts a leading space when the field doesn't already end in whitespace.
export default function appendUserMention<T extends MentionValues>(prev: T, user: TaggableUserOption): T {
  const includeSpace = prev.text.length !== 0 && !prev.text.match(/\s$/);
  const userMention = `@{{${user.display}||${user.id}}}`;

  return {
    ...prev,
    text: prev.text + (includeSpace ? ' ' : '') + userMention,
    plaintext: prev.plaintext + (includeSpace ? ' ' : '') + `@${user.display.split(' - ')[0]}`,
    mentions: [
      ...prev.mentions,
      {
        id: user.id,
        display: user.display,
        index: prev.text.length + (includeSpace ? 1 : 0),
        plainTextIndex: prev.plaintext.length + (includeSpace ? 1 : 0),
        childIndex: prev.mentions.length,
      },
    ],
  };
}
